import React from "react";
import { Card, CardBody } from "reactstrap";
import Page from "../../../../components/Page";
import StepperCompromiso from "../StepperCompromiso";
import "./CrearCompromiso.css";

const CrearCompromisoLayout = ({
    activeStep,
    tituloPaso,
    children
}) => {

    return (
        <main className="bg-light">
            <div className="cr-content container-fluid">
                <div className="container-body-spaces">

                    <Page
                        false
                        breadcrumbs={[
                            {
                                name: "Compromisos",
                                active: true
                            }
                        ]}
                    >

                        <Card className="compromiso-card border-0">

                            <h2 className="compromiso-section-title">
                                Nuevo compromiso
                            </h2>

                            <CardBody className="compromiso-card-body">

                                <StepperCompromiso
                                    activeStep={activeStep}
                                />

                                <h3 className="compromiso-section-subtitle">
                                    {tituloPaso}
                                </h3>

                                {children}

                            </CardBody>

                        </Card>

                    </Page>

                </div>
            </div>
        </main>
    );
};

export default CrearCompromisoLayout;